var map = {
	"./FlaxSmall.png": 42653,
	"./behodler.png": 26922,
	"./behodler.svg": 85260,
	"./burn.png": 15476,
	"./ethPriceTilting.png": 4356,
	"./ether.png": 64419,
	"./eye-eth.png": 75042,
	"./eye-treasure.png": 80464,
	"./eye.png": 30052,
	"./faucet.png": 71095,
	"./flax-eth.png": 56448,
	"./flax-eth2.png": 22512,
	"./flax-ethOrig.png": 79279,
	"./hedgeyIcon.png": 23972,
	"./padlock.png": 52389,
	"./pyro-scx-eth.png": 41128,
	"./pyro-scx-eye.png": 50402,
	"./scarcity.png": 1845,
	"./scx-eth.png": 55855,
	"./scx-eye.png": 19397,
	"./shibPriceTilt.png": 4405,
	"./shibaInu.png": 434,
	"./shibaswap.png": 25875,
	"./sortAscending.svg": 78393,
	"./sortDescending.svg": 42787,
	"./toasty.png": 3805,
	"./uniPriceTilt.png": 94675,
	"./uniToken.png": 18266,
	"./uniswap.png": 4240,
	"./uniswap.svg": 79276
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3907;